
export default {
  props: {
    keys: {
      type: Array,
      default: []
    }
  },

  computed: {
    roles: function roles() {
      return this.$store.getters.roles;
    },
    routeKey: function routeKey() {
      return this.$route.meta.roles;
    }
  }
};